module.exports = __webpack_public_path__ + "img/loader.01e103e1.gif";